import { PacketType } from '@/models/Packet';
import Packet from '@/models/Packet'
import ProjectServer from '@/models/ProjectServer'

export function SendRawPacket(type : PacketType, data : object, fakeBounceBackIfNoServer : Boolean = false) : void
{
	let packet = new Packet(type, data);
	if (!ProjectServer.instanceExists)
	{
		if (fakeBounceBackIfNoServer)
		{
			let msg = new MessageEvent('message');
			(msg as any).data = JSON.stringify(packet);
			ProjectServer.instance.dataReceived(msg);
		}
		return;
	}

	console.log('Sending packet');
	console.log(packet);
	ProjectServer.instance.sendPacket(packet);
}

export function SendPacket<DataType>(type: PacketType, data: DataType) : void
{
	SendRawPacket(type, data as any);
}

export function SendPacketForNode<DataType>(type: PacketType, nodeid: number, data: DataType) : void
{
	let adata = data as any;
	adata.nodeid = nodeid;
	SendRawPacket(type, adata);
}